import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly, MobileOnlyView } from 'react-device-detect';

import { FullPageModal } from '../Shared/Modal';
import { MaterialSpecs } from './MaterialSpecs';
import { Assumptions } from './Assumptions';
import { Exclusion } from './Exclusion';
import { Hardware } from './Hardware';
import { TabbedPanel } from '../Shared/TabbedPanel';
import { Warranty } from './Warranty';
import { CivilAssumption } from './CivilAssumptions';
import { CarpentryAssumption } from './CarpentryAssumptions';

import './view-assumption.scss';

const ViewAssumption = () => {
  const {
    // eslint-disable-next-line no-unused-vars
    viewAssumption: { show = false, data: { loadTab } = {} },
  } = useSelector(state => state.modal);
  const [selectedTab, setSelectedTab] = useState('assumptions');
  const dispatch = useDispatch();
  const tabs = [
    {
      title: 'Assumptions',
      value: 'assumptions',
      component: <Assumptions />,
      viewAvailableFor: new Set(['mobile', 'web']),
    },
    {
      title: 'Material Specs',
      value: 'materialSpecs',
      component: <MaterialSpecs />,
      viewAvailableFor: new Set(['web']),
    },
    {
      title: 'Hardware Specs',
      value: 'hardware',
      component: <Hardware />,
      viewAvailableFor: new Set(['web']),
    },
    {
      title: 'Exclusions',
      value: 'exclusion',
      component: <Exclusion />,
      viewAvailableFor: new Set(['web']),
    },
    {
      title: 'Warranty',
      value: 'warranty',
      component: <Warranty />,
      viewAvailableFor: new Set(['web', 'mobile']),
    },
    {
      title: 'Civil Glossary',
      value: 'civil',
      component: <CivilAssumption />,
      viewAvailableFor: new Set(['web']),
    },
    {
      title: 'Carpentry Glossary',
      value: 'carpentry',
      component: <CarpentryAssumption />,
      viewAvailableFor: new Set(['web']),
    },
    {
      title: 'Material Specs',
      value: 'materialAndHardwareSpecs',
      component: (
        <>
          <MaterialSpecs />
          <div className="tw-pt-4 tw-bg-white hardware-specs">
            <h6>Hardware</h6>
            <Hardware />
          </div>
        </>
      ),
      viewAvailableFor: new Set(['mobile']),
    },
  ];

  const handleTabClick = tab => setSelectedTab(tab);
  const handleClose = () => dispatch({ type: 'HIDE_ASSUMPTION' });
  const { component } = tabs.find(tab => tab.value === selectedTab);

  if (!show) {
    return null;
  }

  return (
    <>
      {!isMobileOnly && (
        <FullPageModal open={show} onClose={handleClose}>
          <div className="other-assumptions">
            <h1>Assumptions & Other Info</h1>
            <div className="assumptions-body">
              <TabbedPanel
                align="start"
                onTabClick={handleTabClick}
                selectedTab={selectedTab}
                bodyStyle={{
                  backgroundColor: '#fafafa',
                }}
                tabs={tabs.filter(tab => tab.viewAvailableFor.has('web'))}
              >
                {component}
              </TabbedPanel>
            </div>
          </div>
        </FullPageModal>
      )}
      <MobileOnlyView>
        <FullPageModal
          open={show}
          showClose
          styleClasses={['pt-4', 'mobile-other-assumptions-wrapper']}
          onClose={handleClose}
        >
          <div className="mobile-other-assumptions">
            <h6 className="pt-5">Assumptions & Other Info</h6>
            <div className="assumptions-body">
              <TabbedPanel
                align="start"
                onTabClick={handleTabClick}
                selectedTab={selectedTab}
                bodyStyle={{
                  backgroundColor: '#fafafa',
                }}
                tabs={tabs.filter(tab => tab.viewAvailableFor.has('mobile'))}
              >
                {component}
              </TabbedPanel>
            </div>
          </div>
        </FullPageModal>
      </MobileOnlyView>
    </>
  );
};

export { ViewAssumption };
